var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"thanks_wrp"},[_c('div',{staticClass:"page-container"},[_vm._m(0),_c('div',{staticClass:"return-button"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Return home")])],1)])]),_c('div',{staticClass:"blue-line"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"omnes fw-semibold eyebrow-page"},[_c('span',{staticClass:"omnes"},[_vm._v("Thank you for submitting")])])
}]

export { render, staticRenderFns }